import React, { useEffect, useState } from "react";
import { useLanguage } from "../tools/LanguageContext";
import { Link } from "react-router-dom";
import AOS from "aos";

function AboutUs() {
  const { translations } = useLanguage();
  const [activeTab, setActiveTab] = useState("tab1");

  useEffect(() => {
      AOS.init({ duration: 1000 });
  });

  return (
    <div className="bg-gray-900 text-white min-h-screen p-4 w-full max-w-screen overflow-x-hidden">
      {/* Header */}
      <header className="flex justify-between items-center p-4 bg-gray-800 rounded-lg">
        <h1 className="text-3xl font-bold">ART OF BETTING</h1>
        <nav className="flex space-x-4">
          <Link to="/">
            <button className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
              {translations.home}
            </button>
          </Link>
        </nav>
      </header>

      {/* Tab Buttons */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
        <button
          onClick={() => setActiveTab("tab1")}
          className={`px-4 py-2 rounded ${
            activeTab === "tab1" ? "bg-green-800" : "bg-gray-700"
          } hover:bg-green-900`}
        >
          {translations.aboutUs}
        </button>
        <button
          onClick={() => setActiveTab("tab2")}
          className={`px-4 py-2 rounded ${
            activeTab === "tab2" ? "bg-green-800" : "bg-gray-700"
          } hover:bg-green-900`}
        >
          {translations.mrArber}
        </button>
        <button
          onClick={() => setActiveTab("tab3")}
          className={`px-4 py-2 rounded ${
            activeTab === "tab3" ? "bg-green-800" : "bg-gray-700"
          } hover:bg-green-900`}
        >
          {translations.vretanos}
        </button>
        <button
          onClick={() => setActiveTab("tab4")}
          className={`px-4 py-2 rounded ${
            activeTab === "tab4" ? "bg-green-800" : "bg-gray-700"
          } hover:bg-green-900`}
        >
          {translations.nole}
        </button>
      </div>

      {/* Tab Content */}
      <main className="mt-6">
        {activeTab === "tab1" && (
          <div
            data-aos="zoom-out-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <h2 className="text-3xl font-bold mb-4">{translations.aboutUs}</h2>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h3 className="text-2xl font-semibold mb-2">{translations.welcome}</h3>
              <p className="mb-4">
                {translations.welcomeText1}
                <br/><br/>
                {translations.welcomeText2}
              </p>

              <h3 className="text-2xl font-semibold mb-2">{translations.whatYouWillFind}</h3>
              <ul className="list-disc pl-6 mb-4">
                <li>{translations.analysisPredictions}</li>
                <li>{translations.bettingStrategies}</li>
                <li>{translations.bettingNews}</li>
                <li>{translations.bankrollManagement}</li>
              </ul>

              <h3 className="text-2xl font-semibold mb-2">{translations.ourGoal}</h3>
              <p className="mb-4">
                {translations.ourGoalText1}
                <br/><br/>
                {translations.ourGoalText2}
              </p>
            </div>
          </div>
        )}

        {activeTab === "tab2" && (
          <div
            data-aos="zoom-out-down"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <h2 className="text-3xl font-bold mb-4">{translations.mrArber}</h2>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h3 className="text-2xl font-semibold mb-2">{translations.whoIsMrArber}</h3>
              <p className="mb-4">
                {translations.mrArberText1}
                <br/><br/>
                {translations.mrArberText2}
                <br/><br/>
                {translations.mrArberText3}
                <br/><br/>
                {translations.mrArberText4}
              </p>
            </div>
          </div>
        )}

        {activeTab === "tab3" && (
          <div
            data-aos="zoom-out-left"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <h2 className="text-3xl font-bold mb-4">{translations.vretanos}</h2>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h3 className="text-2xl font-semibold mb-2">{translations.whoIsVretanos}</h3>
              <p className="mb-4">
                {translations.vretanosText1}
                <br/><br/>
                {translations.vretanosText2}
                <br/><br/>
                {translations.vretanosText3}
              </p>
            </div>
          </div>
        )}

        {activeTab === "tab4" && (
          <div
            data-aos="zoom-out-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <h2 className="text-3xl font-bold mb-4">{translations.nole}</h2>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h3 className="text-2xl font-semibold mb-2">{translations.whoIsNole}</h3>
              <p className="mb-4">
                {translations.noleText1}
                <br/><br/>
                {translations.noleText2}
                <br/><br/>
                {translations.noleText3}
              </p>
            </div>
          </div>
        )}
      </main>

      <footer className="relative w-full bg-gray-900 py-8">
        <div className="flex flex-col items-center justify-between w-full">
          <p className="text-xl font-bold border-b border-t p-4 mb-8">© Copyright 2025 Art Of Betting</p>
          <p className="text-lg font-bold border-b border-t p-2 mb-8 text-center">
            <span className="font-semibold">Διαφημιστειτε εδώ:</span>{' '}
            <a href="mailto:artofbetting2025@gmail.com" className="hover:underline">
              artofbetting2025@gmail.com
            </a>
          </p>

          <div className="flex items-center justify-between w-2/5 mb-8">
            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-1/5 mr-8">
              <img
                src="images/21.svg"
                alt="21+"
                className="w-full h-auto"
              />
            </a>

            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-4/5">
              <img
                src="images/kethea.svg"
                alt="kethea"
                className="w-full h-auto"
              />
            </a>
          </div>

          <a href="https://certifications.gamingcommission.gov.gr/publicRecordsOnline/SitePages/AffiliatesOnline.aspx" target="_blank" rel="noopener noreferrer">
            <img
              src="images/eeep.png"
              alt="eeep"
              className="w-full h-auto border-b border-t p-4"
            />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default AboutUs;